import { createContext } from "react";
import { AppActionType } from "./reducer";
import { AppStateType, initialState } from "./state";

export const AppStateContext = createContext<AppStateType>(initialState);
export const AppDispatchContext = createContext<React.Dispatch<AppActionType>>(
  () => null
);
